import { createContext, useContext } from "react";
import type { TreeEnvironmentRef } from "react-complex-tree";

export const TreeContext = createContext<{
	treeRef: TreeEnvironmentRef | null;
	treeId: string;
} | null>(null);

export const useTreeContext = () => {
	const context = useContext(TreeContext);
	if (context === undefined) {
		throw new Error("useTreeContext must be used within a TreeContextProvider");
	}
	return context;
};
